




















































































































import mixins from 'vue-typed-mixins';
import buildEntityListComponentMixin from '@/Shared/CommonEntityMixins/EntityListComponentMixin';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import { BehaviorProfile } from '@/Admin/LotMaintenance/BehaviorProfile';
import { LocationLookupType } from '@/Stores/LookupStore';

const component = mixins(LocationBasedMixin, buildEntityListComponentMixin<BehaviorProfile>()).extend({
    name: 'BehaviorProfile',
    components: {
        RadioToggle: () => import('@/Shared/RadioToggle.vue'),
    },
    data() {
        return {
            i18nPrefix: 'admin.behaviorProfile',
            LocationLookupType,
        };
    },
    methods: {
        onDeleteError(e: any) {
            if (!e.response || e.response.status !== 409) {
                // continue normally
                return true;
            }

            const translatedTitle =
                this.$i18n.t(`${this.i18nPrefix}.deleteFailedTitle`);
            const translatedMessage =
                this.$i18n.t(`${this.i18nPrefix}.profileInUseMessage`);
            this.$bvToast.toast(translatedMessage.toString(), {
                title: translatedTitle.toString(),
                autoHideDelay: 5000
            });

            return false;
        },
    },
    computed: {
        entityUrls() {
            return `${this.location}/Violations/profiles`;
        }
    }
});

export default component;

